<template>
    <!-- <AppLayout title="Admins"> -->
         
         
         <v-card class="d-flex flex-column flex-grow-1 table-card overflow-visible" :class="tableCard.card.class" :rounded="tableCard.card.rounded">
             <v-card-text class="d-flex flex-column flex-grow-1" :class="tableCard.card.textClass">
                 <div class="d-flex align-center ga-3 px-3 px-md-0" :class="[tableCard.card.actionPad]">
                     <div class="d-flex flex-grow-1 min-w-0">
                         <div class="w-100 w-md-20rem max-w-100">
                             <v-text-field
                                 v-model="datatable.request.search.value"
                                 :label="tableCard.searchInput.label"
                                 :placeholder="tableCard.searchInput.placeholder"
                                 :density="tableCard.searchInput.density"
                                 :flat="tableCard.searchInput.flat"
                                 :variant="tableCard.searchInput.variant"
                                 :single-line="tableCard.searchInput.singleLine"
                                 :hide-details="true"
                                 @update:model-value="() => datatable.onSearch()"
                                 clearable
                                 :class="[`table-action`, tableCard.searchInput.class]"
                             >
                             <template #prepend-inner >
                                 <span >
                                     <mdi-icon>search</mdi-icon>
                                 </span>
                             </template>
                             </v-text-field>
                         </div>
                     </div>
                 </div>
                 <div class="d-flex-col-grow">
                     <DataTable :datatable="datatable" class="d-flex flex-column has-action"  >
                         <template v-slot:[`item.sign_status`]="{ item }:{item: Company}" key="item.sign_status">
                             <div :class="`fw-medium text-${item?.sign_status_preview?.color ?? 'secondary'}`">{{ item?.sign_status_preview?.name ?? 'Not found' }}</div>
                        </template>
                        <template v-slot:[`item.action`]="{ item }:{item: Company}" key="item.action">
                            <div>
                                <div class="d-none d-md-block">
                                    <div class="d-flex justify-center">
                                        <v-tooltip text="Delete">
                                            <template v-slot:activator="{ props }">
                                                <v-btn-icon-text color="danger" @click="deleteForm_Confirm(item)">
                                                    <mdi-icon>delete</mdi-icon>
                                                </v-btn-icon-text>
                                            </template>
                                        </v-tooltip>
                                    </div>
                                </div>
                                <div class="d-md-none">
                                    <v-btn-icon :color="tableCard.actionMenu.btn.color" density="compact" variant="plain">
                                        <mdi-icon>{{ tableCard.actionMenu.btn.icon }}</mdi-icon>

                                        <v-menu activator="parent" class="tiny-dropdown">
                                            <v-list min-width="120px">
                                                <v-list-item title="Delete" color="danger" value="delete_admin" @click="deleteForm_Confirm(item)">
                                                        <template #prepend>
                                                            <mdi-icon>delete</mdi-icon>
                                                        </template>
                                                    </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-btn-icon>
                                </div>
                            </div>
                            
                        </template>
                    </DataTable>
                 </div>
                 
                 
             </v-card-text>
         </v-card>

         <v-dialog v-model="deleteForm.show" width="auto" @afterLeave="deleteForm_Close">
            <v-card max-width="100%" width="500">
                <v-card-title>Delete Company</v-card-title>
                <v-card-subtitle>Are you sure you want to delete this Company?</v-card-subtitle>
                <v-card-text class="py-2">
                    <div v-if="deleteForm.errors.custom_error" class="text-error">{{ deleteForm.errors.custom_error }}</div>
                </v-card-text>
                <v-card-actions-modal>
                    <v-btn
                        text="Cancel"
                        color="btn-secondary"
                        @click="deleteForm_Close"
                    ></v-btn>
                    <v-btn
                        :disabled="deleteForm.processing"
                        :loading="deleteForm.processing"
                        @click="deleteForm_Submit"
                        color="error"
                        text="Delete"
                    ></v-btn>
                </v-card-actions-modal>
            </v-card>
        </v-dialog>
    <!-- </AppLayout> -->
 </template>
 <script setup lang="ts">
    import { ref } from "vue";
    import { Page, GlobalEventCallback } from '@inertiajs/core';
    import { usePage, Link, useForm } from '@inertiajs/vue3';
    import { SharedPageProps } from '@/Types/inertia';
    import { Company } from '@/Types/Models/company';
    import { useDatatable, TableResponse } from '@/Composables/Datatable';
    import { toast } from "vue3-toastify";
    import { pageTitle, useTableCard, containerGapForTable } from '@/Composables/PageMeta';
    import DataTable from '@/Components/vuetify/DataTable.vue';
    import InvoiceDialog from '@/Pages/Invoices/Manage.vue';

    containerGapForTable();
    type PageData = SharedPageProps & {
        data:{
            table?: TableResponse<Company>;
        };
    }
    const page = usePage<PageData>();
    pageTitle.value = 'Companies';
    const datatable = useDatatable<Company>(route('companies.superadmin.index'), page.props.data.table);
    console.log(datatable.request.length)

    const tableCard = useTableCard();

    const deleteForm = useForm<{
        show: boolean,
        item: Company | null,
        custom_error: string,
    }>({
        show: false,
        item: null,
        custom_error: '',
    });
    const deleteForm_Confirm = (item: Company) => {
        deleteForm.reset();
        deleteForm.clearErrors();
        deleteForm.item = item;
        deleteForm.show = true;
    }
    const deleteForm_Close = () => {
        deleteForm.reset();
        deleteForm.clearErrors();
    }
    const deleteForm_Submit = () => {
        deleteForm.transform((data) => ({
            custom_error: data.custom_error
        })).delete(route('companies.superadmin.delete', deleteForm.item?.id), {
            preserveScroll: true,
            onSuccess: ((page: Page<PageData>) => {
                deleteForm_Close();
                toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Company is deleted');
                datatable.setTable(page.props.data.table);
            }) as GlobalEventCallback<"success">,
        });
    }
    
 </script>